import { useEffect } from 'react';

interface UnsavedChangesWarningProps {
  isDirty: boolean;
  isSubmitting: boolean;
}

export const useUnsavedChangesWarning = ({ isDirty, isSubmitting }: UnsavedChangesWarningProps) => {
  useEffect(() => {
    const handleBeforeUnloadHandler = (e: BeforeUnloadEvent) => {
      if (isDirty && !isSubmitting) {
        e.preventDefault();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnloadHandler);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnloadHandler);
    };
  }, [isDirty, isSubmitting]);
};
